export default "__VITE_ASSET__5aa44bda__"